import wNumb from 'wnumb';

export const getPipeStep = (number, length) => {
  switch (true) {
    case number <= 8 && number <= length:
      return 4;
    case number <= 12 && number <= length:
      return 3;
    case number <= 24 && number <= length:
      return 2;
    default:
      return 1;
  }
};

export const decimal = wNumb({
  decimals: 0,
  encoder: function(a) {
    return a;
  },
  decoder: function(a) {
    return a;
  }
});

export const checkIfFull = hour => {
  return !parseFloat(hour.split(':')[1]);
};

export const format = (sliderdata, toDate) => {
  return {
    to(value) {
      return toDate(sliderdata[value.toFixed(0)]);
    },
    from(value) {
      return toDate(sliderdata[value.toFixed(0)]);
    }
  };
};

export const getSliderProperties = (props, values) => {
  const { radarData, userSettings, mapType } = props;
  const { radar } = userSettings;
  const slider = {};

  slider.sliderdata = radarData && radarData[mapType];
  if (slider.sliderdata) {
    slider.max = slider.sliderdata.length;
    slider.length = slider.sliderdata.length < radar.noSlides ? slider.sliderdata.length : radar.noSlides;
    slider.min = slider.max - slider.length;
    slider.average = slider.max - slider.length / 2;
    slider.value = values || [slider.min, slider.max - 1, slider.max - 1];
    slider.fullHoursLength = 0;
    slider.pip_length = slider.max - 1 - slider.min;
    return slider;
  }
};
